import { Component, Input, OnInit } from '@angular/core';
import { ObservationLog, Properties } from '../../../models/project.model';
import { TranslocoService } from '@ngneat/transloco';
import { CustomFieldWithValue } from '../../../models/custom-fields.model';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
})
export class LogsComponent implements OnInit {
  @Input() logs: ObservationLog[];
  @Input() customFields: CustomFieldWithValue[] = [];

  constructor(public _transloco: TranslocoService) {}

  ngOnInit(): void {
    console.log(this.logs);
  }

  /**
   * Returns the locale-specific "old" properties for observation log (From value).
   * Uses old_ru for Russian, old_ar for Arabic, otherwise old.
   */
  getLogOld(log: ObservationLog): Record<string, unknown> {
    const p = log?.properties as Properties | undefined;
    if (!p?.old) return {};
    const lang = this._transloco.getActiveLang();
    if (lang === 'ru' && p.old_ru) return p.old_ru;
    if (lang === 'ar' && p.old_ar) return p.old_ar;
    return (p.old as Record<string, unknown>) || {};
  }

  /**
   * Returns the locale-specific "attributes" for observation log (To value).
   * Uses attributes_ru for Russian, attributes_ar for Arabic, otherwise attributes.
   */
  getLogAttributes(log: ObservationLog): Record<string, unknown> {
    const p = log?.properties as Properties | undefined;
    if (!p?.attributes) return {};
    const lang = this._transloco.getActiveLang();
    if (lang === 'ru' && p.attributes_ru) return p.attributes_ru;
    if (lang === 'ar' && p.attributes_ar) return p.attributes_ar;
    return (p.attributes as Record<string, unknown>) || {};
  }

  stripHtmlWithSpacing(htmlString: string): string {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;

    return this._extractTextWithSpacing(tempElement).trim();
  }

  private _extractTextWithSpacing(element: HTMLElement): string {
    let text = '';

    element.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent?.trim() + ' ';
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = (node as HTMLElement).tagName.toLowerCase();

        // Add line breaks or spaces for block elements
        if (['p', 'div', 'li', 'br', 'strong', 'ol', 'ul'].includes(tagName)) {
          text += '\n';
        }

        text += this._extractTextWithSpacing(node as HTMLElement);
      }
    });

    return text.replace(/\s+/g, ' ').replace(/\n\s*/g, '\n'); // Clean up extra spaces and line breaks
  }
}
